<div class="tw:w-full tw:px-4">
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:flex-1 tw:px-[15px]">
            <button type="button" class="btn btn-primary" (click)="generateRandomBanner()">Generate Banner</button>
            <button type="button" class="btn btn-danger" (click)="removeBanner()">Remove Banner</button>
        </div>
    </div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:flex-1 tw:px-[15px]">
            <thank-you-banner></thank-you-banner>
        </div>
    </div>
</div>

<!-- <div *ngIf="loading">
    <loading-spinner></loading-spinner>
</div>

<div class="container-fluid p-0 m-0">
    <div class="row p-0 m-0">
      <div class="col-12 p-0 m-0" style="height: 1000px;">
          <chat-bot></chat-bot>
    </div>
</div> -->